module.exports = __webpack_public_path__ + "media/images/preview_recipe_3_thumb-d1a469d4c727967b8f04304fac57cd6a.webp";